import { useState } from "react";
import { useLang, LangSelector } from "../LangContext";
import { supabase } from "../supabase";
import { CSS } from "../styles";
import { ROLE_META } from "../constants";

export default function AuthScreen() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState(""); const [password, setPassword] = useState(""); const [name, setName] = useState(""); const [role, setRole] = useState("architect");
  const [joinCode, setJoinCode] = useState(""); const [joinRole, setJoinRole] = useState("client");
  const [joinSubMode, setJoinSubMode] = useState("new"); // "new" | "existing"
  const [loading, setLoading] = useState(false); const [error, setError] = useState(""); const [success, setSuccess] = useState("");
  const [forgotMode, setForgotMode] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const { t } = useLang();

  const handleLogin = async () => {
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    if (err) { setError(err.message); setLoading(false); return; }
    if (!rememberMe) {
      const sbKey = Object.keys(localStorage).find(k => k.startsWith("sb-") && k.endsWith("-auth-token"));
      if (sbKey) localStorage.removeItem(sbKey);
    }
  };

  const handleForgotPassword = async () => {
    if (!email.trim()) { setError(t("emailRequired")); return; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) { setError(t("emailInvalid")); return; }
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: window.location.origin,
    });
    if (err) { setError(err.message); } else { setSuccess(t("emailSent")); }
    setLoading(false);
  };

  const handleSignup = async () => {
    if (!name.trim()) { setError(t("nameRequired")); return; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) { setError(t("emailInvalid")); return; }
    if (password.length < 8) { setError(t("passwordTooShort")); return; }
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.signUp({ email: email.trim(), password, options: { data: { name: name.trim(), role } } });
    if (err) { setError(err.message); setLoading(false); }
    else { setSuccess(t("accountCreated")); setLoading(false); }
  };

  const Err = () => error ? <div style={{ background: "#2A1212", border: "1px solid #4A2020", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#FC8181" }}>{error}</div> : null;
  const Suc = () => success ? <div style={{ background: "#0A2A12", border: "1px solid #1A4A22", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#A8C97E" }}>{success}</div> : null;

  return (
    <div style={{ background: "#0F0E0C", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif", padding: 24 }}>
      <style>{CSS}</style>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32, justifyContent: "center" }}>
          <div style={{ width: 38, height: 38, background: "#C9A96E", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>⬡</div>
          <span style={{ fontFamily: "'DM Serif Display',serif", fontSize: 26, color: "#E8E2D8" }}>Travea</span>
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <LangSelector />
        </div>
        <div style={{ display: "flex", gap: 4, background: "#1A1916", border: "1px solid #2A2924", borderRadius: 10, padding: 4, marginBottom: 20 }}>
          {[{ v: "login", l: t("login") }, { v: "signup", l: t("signup") }, { v: "join", l: t("join") }].map(t => (
            <button key={t.v} onClick={() => { setMode(t.v); setError(""); setSuccess(""); setForgotMode(false); }} className="btn"
              style={{ flex: 1, padding: "8px 4px", borderRadius: 7, fontSize: 12, fontWeight: mode === t.v ? 600 : 400, background: mode === t.v ? "#C9A96E20" : "none", color: mode === t.v ? "#C9A96E" : "#7A7468", border: mode === t.v ? "1px solid #C9A96E40" : "1px solid transparent" }}>
              {t.l}
            </button>
          ))}
        </div>
        <div className="card" style={{ padding: "26px 24px" }}>

          {mode === "login" && !forgotMode && (<>
            <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 20, fontWeight: 400, color: "#E8E2D8", marginBottom: 20 }}>{t("login")}</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <input type="email" placeholder={t("email")} value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} />
              <div>
                <input type="password" placeholder={t("password")} value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} />
                <button onClick={() => { setForgotMode(true); setError(""); setSuccess(""); }} className="btn" style={{ fontSize: 11, color: "#7A7468", marginTop: 8, padding: 0, textDecoration: "underline", textUnderlineOffset: 2 }}>
                  {t("forgotPassword")}
                </button>
              </div>
              <label style={{ display: "flex", alignItems: "center", gap: 9, cursor: "pointer", userSelect: "none" }}>
                <div onClick={() => setRememberMe(p => !p)} style={{ width: 18, height: 18, borderRadius: 5, border: `1.5px solid ${rememberMe ? "#C9A96E" : "#3A3830"}`, background: rememberMe ? "#C9A96E" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all 0.15s" }}>
                  {rememberMe && <span style={{ fontSize: 11, color: "#0F0E0C", fontWeight: 700 }}>✓</span>}
                </div>
                <span style={{ fontSize: 12, color: "#7A7468" }}>{t("rememberMe")}</span>
              </label>
              <Err /><Suc />
              <button onClick={handleLogin} disabled={loading} className="btn" style={{ background: "#C9A96E", color: "#0F0E0C", borderRadius: 10, padding: 13, fontSize: 14, fontWeight: 600, border: "none" }}>
                {loading ? <div style={{ display: "flex", justifyContent: "center" }}><div className="spinner" style={{ borderTopColor: "#0F0E0C" }} /></div> : t("signIn")}
              </button>
            </div>
          </>)}

          {mode === "login" && forgotMode && (<>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <button onClick={() => { setForgotMode(false); setError(""); setSuccess(""); }} className="btn" style={{ fontSize: 18, color: "#7A7468", padding: 0 }}>←</button>
              <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 20, fontWeight: 400, color: "#E8E2D8" }}>{t("resetPassword")}</h2>
            </div>
            <p style={{ fontSize: 12, color: "#5A5450", marginBottom: 16 }}>{t("resetDesc")}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <input type="email" placeholder={t("email")} value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleForgotPassword()} />
              <Err /><Suc />
              <button onClick={handleForgotPassword} disabled={loading} className="btn" style={{ background: "#C9A96E", color: "#0F0E0C", borderRadius: 10, padding: 13, fontSize: 14, fontWeight: 600, border: "none" }}>
                {loading ? t("sending") : t("sendLink")}
              </button>
            </div>
          </>)}

          {mode === "signup" && (<>
            <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 20, fontWeight: 400, color: "#E8E2D8", marginBottom: 20 }}>{t("createAccount")}</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <input placeholder={t("fullName")} value={name} onChange={e => setName(e.target.value)} />
              <input type="email" placeholder={t("email")} value={email} onChange={e => setEmail(e.target.value)} />
              <input type="password" placeholder={t("passwordMin")} value={password} onChange={e => setPassword(e.target.value)} />
              <div>
                <div className="sl" style={{ marginBottom: 8 }}>{t("yourRole")}</div>
                <div style={{ display: "flex", gap: 8 }}>
                  {[{ v: "architect", l: t("roleArchitect") }, { v: "contractor", l: t("roleContractor") }, { v: "client", l: t("roleClient") }].map(r => (
                    <button key={r.v} onClick={() => setRole(r.v)} className="btn"
                      style={{ flex: 1, padding: "8px 4px", borderRadius: 8, fontSize: 11, fontWeight: role === r.v ? 600 : 400, background: role === r.v ? `${ROLE_META[r.v].color}20` : "#252420", border: `1px solid ${role === r.v ? ROLE_META[r.v].color + "60" : "#2A2924"}`, color: role === r.v ? ROLE_META[r.v].color : "#7A7468" }}>
                      {r.l}
                    </button>
                  ))}
                </div>
              </div>
              <Err /><Suc />
              <button onClick={handleSignup} disabled={loading} className="btn" style={{ background: "#C9A96E", color: "#0F0E0C", borderRadius: 10, padding: 13, fontSize: 14, fontWeight: 600, border: "none" }}>
                {loading ? t("loading") : t("createAccountBtn")}
              </button>
            </div>
          </>)}

          {mode === "join" && (<>
            <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 20, fontWeight: 400, color: "#E8E2D8", marginBottom: 16 }}>{t("joinProject")}</h2>

            {/* Sub-toggle */}
            <div style={{ display: "flex", gap: 4, background: "#1A1916", border: "1px solid #2A2924", borderRadius: 8, padding: 3, marginBottom: 20 }}>
              {[{ v: "new", l: t("newAccount") }, { v: "existing", l: t("existingAccount") }].map(t => (
                <button key={t.v} onClick={() => { setJoinSubMode(t.v); setError(""); setSuccess(""); }} className="btn"
                  style={{ flex: 1, padding: "7px 4px", borderRadius: 6, fontSize: 12, fontWeight: joinSubMode === t.v ? 600 : 400, background: joinSubMode === t.v ? "#C9A96E20" : "none", color: joinSubMode === t.v ? "#C9A96E" : "#7A7468", border: joinSubMode === t.v ? "1px solid #C9A96E40" : "1px solid transparent" }}>
                  {t.l}
                </button>
              ))}
            </div>

            {/* Code du projet — commun aux deux */}
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <div className="sl" style={{ marginBottom: 6 }}>{t("projectCode")}</div>
                <input placeholder="CODE (ex: AB3KZ9)" value={joinCode} onChange={e => setJoinCode(e.target.value.toUpperCase())} style={{ textAlign: "center", fontSize: 22, fontWeight: 700, letterSpacing: "0.2em" }} />
              </div>
              <div style={{ height: 1, background: "#2A2924" }} />

              {/* Nouveau compte */}
              {joinSubMode === "new" && (<>
                <input placeholder={t("fullName")} value={name} onChange={e => setName(e.target.value)} />
                <input type="email" placeholder={t("email")} value={email} onChange={e => setEmail(e.target.value)} />
                <input type="password" placeholder={t("passwordMin")} value={password} onChange={e => setPassword(e.target.value)} />
                <div>
                  <div className="sl" style={{ marginBottom: 8 }}>{t("yourRoleOnProject")}</div>
                  <div style={{ display: "flex", gap: 8 }}>
                    {[{ v: "client", l: t("roleClient") }, { v: "contractor", l: t("roleContractor") }].map(r => (
                      <button key={r.v} onClick={() => setJoinRole(r.v)} className="btn"
                        style={{ flex: 1, padding: "8px 4px", borderRadius: 8, fontSize: 11, fontWeight: joinRole === r.v ? 600 : 400, background: joinRole === r.v ? `${ROLE_META[r.v].color}20` : "#252420", border: `1px solid ${joinRole === r.v ? ROLE_META[r.v].color + "60" : "#2A2924"}`, color: joinRole === r.v ? ROLE_META[r.v].color : "#7A7468" }}>
                        {r.l}
                      </button>
                    ))}
                  </div>
                </div>
                <Err /><Suc />
                <button onClick={async () => {
                  if (!joinCode.trim()) { setError(t("codeRequired")); return; }
                  if (!name.trim()) { setError(t("nameRequired")); return; }
                  if (!email.trim()) { setError("Email requis"); return; }
                  const emailRegexJ = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegexJ.test(email.trim())) { setError(t("emailInvalid")); return; }
                  if (!password || password.length < 8) { setError(t("passwordTooShort")); return; }
                  setLoading(true); setError("");
                  const { error: signupErr } = await supabase.auth.signUp({ email: email.trim(), password, options: { data: { name: name.trim(), role: joinRole } } });
                  if (signupErr) { setError(signupErr.message); setLoading(false); return; }
                  const { error: loginErr } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
                  if (loginErr) { setSuccess(t("accountCreatedLogin")); setLoading(false); return; }
                  let ready = false;
                  for (let i = 0; i < 10; i++) {
                    await new Promise(r => setTimeout(r, 500));
                    const { data: pCheck } = await supabase.from("profiles").select("id").eq("id", (await supabase.auth.getUser()).data.user?.id).single();
                    if (pCheck) { ready = true; break; }
                  }
                  if (!ready) { setError(t("profileError")); setLoading(false); return; }
                  const { error: joinErr } = await supabase.rpc("join_project_by_code", { code: joinCode.trim().toUpperCase(), joining_role: joinRole });
                  if (joinErr) { setError(t("invalidCode")); setLoading(false); return; }
                  setLoading(false);
                }} disabled={loading} className="btn" style={{ background: "#C9A96E", color: "#0F0E0C", borderRadius: 10, padding: 13, fontSize: 14, fontWeight: 600, border: "none" }}>
                  {loading ? t("creatingAccount") : t("createAndJoin")}
                </button>
              </>)}

              {/* Déjà un compte */}
              {joinSubMode === "existing" && (<>
                <input type="email" placeholder={t("email")} value={email} onChange={e => setEmail(e.target.value)} />
                <input type="password" placeholder={t("password")} value={password} onChange={e => setPassword(e.target.value)} />
                <Err /><Suc />
                <button onClick={async () => {
                  if (!joinCode.trim()) { setError(t("codeRequired")); return; }
                  if (!email.trim() || !password) { setError(t("emailAndPasswordRequired")); return; }
                  setLoading(true); setError("");
                  const { error: loginErr } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
                  if (loginErr) { setError(t("wrongCredentials")); setLoading(false); return; }
                  const { error: joinErr } = await supabase.rpc("join_project_by_code", { code: joinCode.trim().toUpperCase(), joining_role: joinRole });
                  if (joinErr) { setError(t("invalidCode")); setLoading(false); return; }
                  setLoading(false);
                }} disabled={loading} className="btn" style={{ background: "#C9A96E", color: "#0F0E0C", borderRadius: 10, padding: 13, fontSize: 14, fontWeight: 600, border: "none" }}>
                  {loading ? t("connectingAccount") : t("signInAndJoin")}
                </button>
              </>)}
            </div>
          </>)}
        </div>
      </div>
    </div>
  );
}
